import { post, get } from './api';

export function confirmSmsCode({ phone, code }) {
    if (process.env.NODE_ENV === 'development') {
        return new Promise((res, rej) => {
            setTimeout(res, 1500);
        });
    }

    return get(`verification/verificationcode?phone=${phone}&code=${code}`)
        .catch((res) => {
            return Promise.reject({
                ...res,
                message: res.status === 400
                    ? 'Неверный смс-код'
                    : res.message,
            });
        });
}

export function sendSmsCode(phone) {
    if (process.env.NODE_ENV === 'development') {
        return new Promise((res, rej) => {
            setTimeout(res, 2500);
        });
    }

    return get('verification/sendverificationcode?phone=' + phone);
}



// WEBPACK FOOTER //
// ./src/services/api/verification.js